import { render } from "./Acceptances.vue?vue&type=template&id=e68bf280"
import script from "./Acceptances.vue?vue&type=script&lang=js"
export * from "./Acceptances.vue?vue&type=script&lang=js"

import "./Acceptances.vue?vue&type=style&index=0&id=e68bf280&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QSpinner,QBanner,QBtn,QTable,QInnerLoading,QTr,QTd,QSpace});
